import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { VersionCheckService } from './core/services/version-check.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
    showUpdatePrompt = false;
    availableVersion = '';

    private readonly destroy$ = new Subject<void>();

    constructor(private readonly versionCheckService: VersionCheckService) {}

    ngOnInit(): void {
        this.versionCheckService.initVersionCheck();
        this.versionCheckService.updateAvailable$
            .pipe(takeUntil(this.destroy$))
            .subscribe((version) => {
                if (version) {
                    this.availableVersion = version;
                    this.showUpdatePrompt = true;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.versionCheckService.stopVersionCheck();
    }

    reloadApp(): void {
        this.showUpdatePrompt = false; 
        void this.versionCheckService.applyUpdate();
    }
}
